
<gw-page-status buttonLabel="Go to audits" buttonUrl="/audits" [status]="status" [message]="message"></gw-page-status>